import api from './axios';

// ---- Stajyerin kendi uçları (sahiplik kontrolü, izin gerektirmez) ----
export const getMyWorkDays = (params) => api.get('/intern/work-days', { params });
export const declareWorkDay = (data) => api.post('/intern/work-days', data);
export const withdrawWorkDay = (id) => api.delete(`/intern/work-days/${id}`);
export const getMyInternPayments = (params) => api.get('/intern/payments', { params });

// ---- Öğretmen/yönetici: gün onayı (interns.attendance.*) ----
export const getInternWorkDays = (params) => api.get('/intern-work-days', { params });
export const createInternWorkDay = (data) => api.post('/intern-work-days', data);
export const approveInternWorkDay = (id, data) => api.patch(`/intern-work-days/${id}/approve`, data);
export const rejectInternWorkDay = (id, data) => api.patch(`/intern-work-days/${id}/reject`, data);
export const deleteInternWorkDay = (id) => api.delete(`/intern-work-days/${id}`);

// ---- Yönetici: ücret/bakiye/ödeme (interns.payments.*, ÖĞRETMENDE YOK) ----
export const getInterns = (params) => api.get('/interns', { params });
export const getInternPayments = (userId, params) => api.get(`/interns/${userId}/payments`, { params });
export const createInternPayment = (userId, data) => api.post(`/interns/${userId}/payments`, data);
export const deleteInternPayment = (id) => api.delete(`/intern-payments/${id}`);
